/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  ActionPointsControllerCreateActionPointV1201,
  ActionPointsControllerCreateActionPointV1PathParameters,
  ActionPointsControllerDeleteActionPointV1PathParameters,
  ActionPointsControllerGetActionPointsV1200,
  ActionPointsControllerGetActionPointsV1PathParameters,
  ActionPointsControllerGetDeviceActionPointsV1200,
  ActionPointsControllerGetDeviceActionPointsV1PathParameters,
  ActionPointsControllerUpdateActionPointV1200,
  ActionPointsControllerUpdateActionPointV1PathParameters,
  CreateActionPointDto,
  UpdateActionPointDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class ActionPointsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all action points available for a client
   */

  getActionPoints<TData = ActionPointsControllerGetActionPointsV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: ActionPointsControllerGetActionPointsV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/action-points`);
  }
  /**
   * @summary Create a new action point
   */

  createActionPoint<TData = ActionPointsControllerCreateActionPointV1201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: ActionPointsControllerCreateActionPointV1PathParameters,
    createActionPointDto: CreateActionPointDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/action-points`, createActionPointDto);
  }
  /**
   * @summary Retrieve all action points available for a device
   */

  getDeviceActionPoints<TData = ActionPointsControllerGetDeviceActionPointsV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: ActionPointsControllerGetDeviceActionPointsV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/action-points/device/${deviceId}`);
  }
  /**
   * @summary Update an action point
   */

  updateActionPoint<TData = ActionPointsControllerUpdateActionPointV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: ActionPointsControllerUpdateActionPointV1PathParameters,
    updateActionPointDto: UpdateActionPointDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/action-points/${id}`, updateActionPointDto);
  }
  /**
   * @summary Delete an action point
   */

  deleteActionPoint<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: ActionPointsControllerDeleteActionPointV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/action-points/${id}`);
  }
}
